import StoreInventoryDisclaimer from './StoreInventoryDisclaimer.js';

const StoreInventoryList = (settings = {}) => {
  let detailsExpanded = false;
  let detailsCTA = 'See Location Details';

  const openDetails = () => {
    if (detailsExpanded) {
      detailsExpanded = false;
      detailsCTA = 'See Location Details';
      detailsExpandedDiv.style.display = 'none';
    } else {
      detailsExpanded = true;
      detailsCTA = 'Hide Location Details';
      detailsExpandedDiv.style.display = 'block';
      if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
          event: 'pdp_local_store_availability_storedetails_click',
        });
      }
    }
    detailsCTAElement.textContent = detailsCTA;
  };

  const addressClick = () => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'store_address_click',
        store_location: settings.store.store_name,
        product_page: window.location.href,
      });
    }
  };

  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'store_address_impression',
      store_location: settings.store.store_name,
      product_page: window.location.href,
    });
  }

  const container = document.createElement('div');
  container.className = 'StoreInventoryList__container';

  const col1 = document.createElement('div');
  col1.className = 'StoreInventoryList__col';

  const storeName = document.createElement('div');
  storeName.className = 'StoreInventoryList__name';
  storeName.textContent = settings.store.store_name;

  const detailsExpandedDiv = document.createElement('div');
  detailsExpandedDiv.className = 'StoreInventoryList__details-expanded';
  detailsExpandedDiv.style.display = 'none';

  if (settings.store.address) {
    const detailsBlock = document.createElement('div');
    detailsBlock.className = 'StoreInventoryList__details-block';
    detailsBlock.addEventListener('click', addressClick);

    const addressLink = document.createElement('a');
    addressLink.href = `https://maps.google.com/?q=Windsor,${settings.store.address.address_line_1},${
      settings.store.address.address_line_2 || ''
    },${settings.store.address.city}, ${settings.store.address.state}, ${settings.store.address.zip_code}`;

    const address1 = document.createElement('p');
    address1.textContent = settings.store.address.address_line_1;
    addressLink.appendChild(address1);

    if (settings.store.address.address_line_2) {
      const address2 = document.createElement('p');
      address2.textContent = settings.store.address.address_line_2;
      addressLink.appendChild(address2);
    }

    const cityStateZip = document.createElement('p');
    cityStateZip.textContent = `${settings.store.address.city}, ${settings.store.address.state} ${settings.store.address.zip_code}`;
    addressLink.appendChild(cityStateZip);

    detailsBlock.appendChild(addressLink);
    detailsExpandedDiv.appendChild(detailsBlock);
  }

  if (settings.store.business_hours && settings.store.business_hours.length > 0) {
    const hoursBlock = document.createElement('div');
    hoursBlock.className = 'StoreInventoryList__details-block';

    settings.store.business_hours.forEach((hours) => {
      const hoursDiv = document.createElement('div');

      if (hours.day.indexOf('-') > -1) {
        const dayP = document.createElement('p');
        dayP.textContent = hours.day;
        const hoursP = document.createElement('p');
        hoursP.textContent = hours.hours;

        hoursDiv.appendChild(dayP);
        hoursDiv.appendChild(hoursP);
      } else {
        const combinedP = document.createElement('p');
        combinedP.textContent = `${hours.day} ${hours.hours}`;
        hoursDiv.appendChild(combinedP);
      }

      hoursBlock.appendChild(hoursDiv);
    });

    detailsExpandedDiv.appendChild(hoursBlock);
  }

  const detailsCTAElement = document.createElement('div');
  detailsCTAElement.className = 'StoreInventoryList__details-cta';
  detailsCTAElement.textContent = detailsCTA;
  detailsCTAElement.addEventListener('click', openDetails);

  col1.appendChild(storeName);
  col1.appendChild(detailsExpandedDiv);
  col1.appendChild(detailsCTAElement);

  const col2 = document.createElement('div');
  col2.className = 'StoreInventoryList__col';

  const quantity = document.createElement('div');
  quantity.className = 'StoreInventoryList__quantity';

  if (settings.store.quantity <= 0) {
    const soldOut = document.createElement('span');
    soldOut.className = 'StoreInventoryList__quantity-reg';
    soldOut.textContent = 'Sold Out';
    quantity.appendChild(soldOut);
  } else if (settings.store.quantity > 0 && settings.store.quantity <= 2) {
    const infoSpan = document.createElement('span');
    infoSpan.className = 'StoreInventoryList__quantity-info';
    infoSpan.setAttribute('data-inventory-disclaimer', '');

    const lowQuantity = document.createElement('span');
    lowQuantity.className = 'StoreInventoryList__quantity-low';
    lowQuantity.textContent = `${settings.store.quantity} Available`;

    const disclaimer = StoreInventoryDisclaimer();

    infoSpan.appendChild(lowQuantity);
    infoSpan.appendChild(disclaimer);
    quantity.appendChild(infoSpan);
  } else {
    const available = document.createElement('span');
    available.className = 'StoreInventoryList__quantity-reg';
    available.textContent = 'Available';
    quantity.appendChild(available);
  }

  const distance = document.createElement('div');
  distance.className = 'StoreInventoryList__distance';
  distance.textContent = `${settings.store.distance.toFixed(2)} miles`;

  col2.appendChild(quantity);
  col2.appendChild(distance);

  container.appendChild(col1);
  container.appendChild(col2);

  return container;
};

export default StoreInventoryList;
